import React from "react";

type SvgIconWithMaskProps = {
  src: string;
  color: string;
  size?: number;
  onError?: React.ReactNode;
};

const SvgIconWithMask: React.FC<SvgIconWithMaskProps> = ({
  src,
  color,
  size = 24,
  onError,
}) => {
  const [error, setError] = React.useState(false);

  React.useEffect(() => {
    if (!src) {
      setError(true);
      return;
    }

    const img = new Image();
    img.src = src;

    img.onload = () => setError(false);
    img.onerror = () => setError(true);
  }, [src]);

  // ❗ Nếu lỗi → render component onError
  if (error) {
    return <>{onError ?? null}</>;
  }

  const style: React.CSSProperties = {
    width: size,
    height: size,
    backgroundColor: color,
    display: 'inline-block',

    WebkitMaskImage: `url(${src})`,
    WebkitMaskRepeat: 'no-repeat',
    WebkitMaskPosition: 'center',
    WebkitMaskSize: 'contain',

    maskImage: `url(${src})`,
    maskRepeat: 'no-repeat',
    maskPosition: 'center',
    maskSize: 'contain',
  };


  return <div style={style} />;
};

export default SvgIconWithMask;